<template>
  <section class="u-clearfix u-custom-color-1 u-section-2" id="blockSection">
    <div class="u-clearfix u-sheet u-sheet-1">
      <div class="u-clearfix u-gutter-18 u-layout-wrap u-layout-wrap-1">
        <div class="u-gutter-0 u-layout">
          <div class="u-layout-row">
            <div class="u-align-left u-container-style u-layout-cell u-radius-5 u-shape-round u-size-60 u-white u-layout-cell-1">
              <div class="u-border-1 u-border-grey-10 u-container-layout u-valign-bottom-lg u-valign-bottom-md u-valign-bottom-xl u-valign-bottom-xxl u-container-layout-1">
                <div class="u-border-1 u-border-grey-5 u-border-no-left u-border-no-right u-border-no-top u-container-style u-group u-group-1">
                  <div class="u-container-layout u-valign-middle u-container-layout-2">
                    <h6 class="u-text u-text-default u-text-1">請求先情報</h6>
                  </div>
                </div>
                <div class="u-container-style u-expanded-width-sm u-expanded-width-xs u-group u-shape-rectangle u-group-2">
                  <div class="u-container-layout u-container-layout-3">
                    <div class="u-expanded-width-xs u-table u-table-responsive u-table-1">
                      <perfect-scrollbar>
                      <table class="u-table-entity">
                        <colgroup>
                          <col width="29.99%">
                          <col width="70.01%">
                        </colgroup>
                        <tbody class="u-table-body">
                          <tr style="height: 26px; white-space: nowrap;">
                            <td class="u-table-cell u-table-valign-bottom u-table-cell-1"></td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-valign-bottom u-table-cell-2">{{ this.seikyusakimei_furigana }}<span style="font-size: 0.625rem;"></span>
                            </td>
                          </tr>
                          <tr style="height: 40px;">
                            <td class="u-table-cell u-table-valign-top u-table-cell-3">会社・団体名</td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-valign-top u-table-cell-4">{{ this.seikyusakimei }}</td>
                          </tr>
                          <tr style="height: 40px;">
                            <td class="u-table-cell u-table-valign-middle u-table-cell-5">部署名</td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-cell-6">{{ this.seikyusaki_bushomei }}</td>
                          </tr>
                          <tr style="height: 20px;">
                            <td class="u-table-cell u-table-valign-bottom u-table-cell-7"></td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-valign-bottom u-table-cell-8">{{ this.seikyusakitanto_furigana }}</td>
                          </tr>
                          <tr style="height: 40px;">
                            <td class="u-table-cell u-table-valign-top u-table-cell-9">請求担当者氏名</td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-valign-top u-table-cell-10">{{ this.seikyusaki_tantoshamei }}</td>
                          </tr>
                          <tr style="height: 40px;">
                            <td class="u-table-cell u-table-cell-11">メールアドレス</td>
                            <td style="word-break: break-all;" class="u-align-left-xs u-table-cell u-table-cell-12">{{ this.seikyusaki_tantosha_email }}</td>
                          </tr>
                          <tr style="height: 40px;">
                            <td class="u-table-cell u-table-cell-13">郵便番号</td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-cell-14">{{ this.seikyusaki_yubinbango }}</td>
                          </tr>
                          <tr style="height: 40px;">
                            <td class="u-table-cell u-table-cell-15">都道府県</td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-cell-16">{{ this.seikyusaki_todofuken }}</td>
                          </tr>
                          <tr style="height: 40px;">
                            <td class="u-table-cell u-table-cell-17">市区群町村</td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-cell-18">{{ this.seikyusaki_shikugunchoson }}</td>
                          </tr>
                          <tr style="height: 40px;">
                            <td class="u-table-cell u-table-cell-19">番地・ビル名</td>
                            <td style="word-break: break-all;" class="u-table-cell u-table-cell-20">{{ this.seikyusaki_banchibuilding }}</td>
                          </tr>
                        </tbody>
                      </table>
                      </perfect-scrollbar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UserInfoSectionSeikyuTantoCmp',
  props: {items: Object},
  data(){
    return{
      blank : "　",
      seikyusakimei_furigana: this.blank,
      seikyusakimei: this.blank,
      seikyusaki_bushomei: this.blank,
      seikyusakitanto_furigana: this.blank,
      seikyusaki_tantoshamei: this.blank,
      seikyusaki_tantosha_email: this.blank,
      seikyusaki_yubinbango: this.blank,
      seikyusaki_todofuken: this.blank,
      seikyusaki_shikugunchoson: this.blank,
      seikyusaki_banchibuilding: this.blank,
    }
  },
  watch: {
    items: function() {
      this.setData();
    }
  },
  created(){
    if(this.items != null){
      this.setData();
    }    
  },
  methods: {
    getValue : function(item){
      return item == undefined || item.length == 0 ? this.blank : item;
    },
    setData(){
      this.seikyusakimei_furigana = this.getValue(this.items.seikyusakimei_furigana?.value);
      this.seikyusakimei = this.getValue(this.items.seikyusakimei?.value);
      this.seikyusaki_bushomei = this.getValue(this.items.seikyusaki_bushomei?.value);
      this.seikyusakitanto_furigana = this.getValue(this.items.seikyusakitanto_furigana?.value);
      this.seikyusaki_tantoshamei = this.getValue(this.items.seikyusaki_tantoshamei?.value);
      this.seikyusaki_tantosha_email = this.getValue(this.items.seikyusaki_tantosha_email?.value);
      this.seikyusaki_yubinbango = this.getValue(this.items.seikyusaki_yubinbango?.value);
      this.seikyusaki_todofuken = this.getValue(this.items.seikyusaki_todofuken?.value);
      this.seikyusaki_shikugunchoson = this.getValue(this.items.seikyusaki_shikugunchoson?.value);
      this.seikyusaki_banchibuilding = this.getValue(this.items.seikyusaki_banchibuilding?.value);
    },
    goToKeiyaku() {
      this.$router.push('/userInfo/keiyaku');
    },
    goToSeikyuTanto() {
      this.$router.push('/userInfo/seikyu');
    }
  }
}
</script>

<style src="../css/UserInfoSectionSeikyuTanto.css" scoped>
</style>

<style scoped>
  section {
    min-height: calc(100vh - 130px);
  }
</style>
